import { all } from 'redux-saga/effects';

import { fetchWhitelistSaga } from './fetchWhitelist';

export function* saga() {
    yield all([fetchWhitelistSaga()]);
}
